var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicle-map",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"top",staticStyle:{"position":"absolute","top":"0px","transform":"scale(0.9)","z-index":"100"}},[_c('target')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }